module.exports = ".md-overlay-pane{\r\n    width:100%;\r\n}\r\n.md-overlay-container{\r\n    position:absolute !important;\r\n}\r\n.mat-sidenav-content {\r\n    -webkit-transform: none !important;\r\n            transform: none !important;\r\n}\r\n@media only screen and (max-width: 320px) {\r\n.mat-tab-label{\r\n    padding: 0 8px 0px 15px!important;\r\n    height:34px!important;\r\n}\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/sendMoney.component.css
// module id = ./src/app/sendMoney/sendMoney.component.css
// module chunks = main